import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Col, Row, Input, Button, Form, Label } from "reactstrap";
import { Redirect, useHistory, useLocation, useParams } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { ItemRequisitionAPI } from "./ItemRequisitionAPI";
import { AlertPopups } from "../../../components/AlertPopups";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FormStatus from "../../../components/FormStatus";
import { Routes } from "../../../configurations/config";

function ReviewItemRequisitionDetail() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const { state } = useLocation();
	const itemStatus = state ? state.itemStatus : null;
	const itemReqDepartmentIds = ["3", "5", "9"]; // To which review Item Requisition should be shown// SSN,accounts,admin
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [ItemRequisitionDetail, setItemRequisitionDetail] = useState({});
	const [supervisorApprovalTypes, setSupervisorApprovalTypes] =
		useState(null);
	const [
		selectedSupervisorApprovalTypes,
		setSelectedSupervisorApprovalTypes,
	] = useState(null);
	const [paidByTypesList, setPaidByTypesList] = useState(null);
	const [selectedPaidByType, setSelectedPaidByType] = useState(null);
	const [supervisorComments, setSupervisorComments] = useState("");

	const validate = Yup.object().shape({
		paidBy: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		approval: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		supervisorComments: Yup.string()
			.required("Comments is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});

	useEffect(() => {
		var tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${ItemRequisitionAPI.GetItemRequisitionRequestDetailById}/${id}`,
				{
					headers: tokenHeader,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setItemRequisitionDetail(data);
				}
			});
		setApiHeaderToken(tokenHeader);
	}, []);

	useEffect(() => {
		var tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		//get Supervisor Approvals List
		axios
			.get(`${ItemRequisitionAPI.GetSupervisorApprovals}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setSupervisorApprovalTypes(
						data.statuses.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					const selected = data.statuses.find((item) =>
						item.label.includes(
							ItemRequisitionDetail.supervisorApproval
						)
					);
					setSelectedSupervisorApprovalTypes(selected);
				}
			});
		//get PaidByTypes List
		axios
			.get(`${ItemRequisitionAPI.GetPaidByTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setPaidByTypesList(
						data.paidBy.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
					const selected = data.paidBy.find((item) =>
						item.label.includes(ItemRequisitionDetail.paidBy)
					);
					setSelectedPaidByType(selected);
				}
			});
	}, [ItemRequisitionDetail]);

	const handleSubmit = () => {
		const formBody = {
			supervisorComments: supervisorComments,
			approval: selectedSupervisorApprovalTypes
				? selectedSupervisorApprovalTypes.value
				: null,
			paidBy: selectedPaidByType ? selectedPaidByType.value : null,
		};

		axios
			.patch(
				`${ItemRequisitionAPI.PatchApproveRejectRequest}/${id}`,
				formBody,
				{
					headers: apiHeaderToken,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Application Reviewed",
					});
					history.push(Routes.ReviewItemRequsition);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return itemReqDepartmentIds.includes(
					userDetails.department.toString()
				) ||
					userDetails.empRole.includes("2") ||
					userDetails.designation.toString() === "4" ||
					userDetails.designation.toString() === "5" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<FormStatus
								id={id}
								title="Review Requested Item Detail"
								formStatus={itemStatus}
								className="create-request d-flex align-items-center"
								onClick={() => {
									history.push(Routes.ReviewItemRequsition);
								}}
								navigateBack={true}
							/>

							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Personal Information</Label>
								</div>
								<Col>
									<Row className="py-2 px-2">
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Name</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.employeeName
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Code</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.employeeCode
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Department</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.department
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{moment(
													ItemRequisitionDetail.date
												).format("DD/MM/YYYY ")}
											</p>
										</Col>
									</Row>
								</Col>
							</div>

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Request Details</Label>
								</div>

								<Row className="py-2 px-4">
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Project Name</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										{ItemRequisitionDetail.projectName
											?.length > 30 ? (
											<Input
												type="textarea"
												name="supComments"
												disabled={true}
												className="supDesciptionBox mb-2"
												value={
													ItemRequisitionDetail.projectName
												}
											/>
										) : (
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.projectName
												}
											</p>
										)}
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Item</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										{ItemRequisitionDetail.item?.length >
										30 ? (
											<Input
												type="textarea"
												name="supComments"
												disabled={true}
												className="supDesciptionBox mb-2"
												value={
													ItemRequisitionDetail.item
												}
											/>
										) : (
											<p className="formValueContainer">
												{ItemRequisitionDetail.item}
											</p>
										)}
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Req. Priority</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{ItemRequisitionDetail.priority}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Description</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<Input
											type="textarea"
											name="supComments"
											disabled={true}
											className="supDesciptionBox"
											value={
												ItemRequisitionDetail.description
											}
										/>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Please justify the need</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<Input
											type="textarea"
											name="supComments"
											disabled={true}
											className="supDesciptionBox"
											value={
												ItemRequisitionDetail.justification
											}
										/>
									</Col>
								</Row>
							</div>
							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Supervisor Approval</Label>
								</div>
								<Formik
									enableReinitialize={true}
									initialValues={{
										paidBy: selectedPaidByType,
										approval:
											selectedSupervisorApprovalTypes,
										supervisorComments: supervisorComments,
									}}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<Form>
											<Row className="py-2 px-4">
												<Col md={12} lg={3}>
													<div className="formDetailHeader">
														<div>Paid By</div>
													</div>
												</Col>
												<Col md={12} lg={3}>
													<CustomReactSelect
														options={
															paidByTypesList
														}
														value={
															selectedPaidByType
														}
														isDisabled={
															itemStatus ===
															"Pending"
																? false
																: true
														}
														onChange={(value) =>
															setSelectedPaidByType(
																value
															)
														}
														className={`supDesciptionBox  ${
															errors.paidBy
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={3}>
													<div className="formDetailHeader">
														<Label>
															Supervisor Approval
														</Label>
													</div>
												</Col>
												<Col md={12} lg={3}>
													<CustomReactSelect
														options={
															supervisorApprovalTypes
														}
														value={
															selectedSupervisorApprovalTypes
														}
														isDisabled={
															itemStatus ===
															"Pending"
																? false
																: true
														}
														onChange={(value) =>
															setSelectedSupervisorApprovalTypes(
																value
															)
														}
														className={`supDesciptionBox ${
															errors.approval
																? "h-auto invalid"
																: "h-auto"
														}`}
													/>
												</Col>
												<Col md={12} lg={3}>
													<div className="formDetailHeader">
														<div>Comments</div>
													</div>
												</Col>
												<Col
													md={12}
													lg={3}
													className="my-1"
												>
													{itemStatus ===
													"Pending" ? (
														<Input
															type="textarea"
															name="supervisorComments"
															className={`supDesciptionBox ${
																errors.supervisorComments
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(event) =>
																setSupervisorComments(
																	event.target
																		.value
																)
															}
															value={
																supervisorComments
															}
															maxLength="400"
														/>
													) : (
														<p className="formValueContainer">
															{
																ItemRequisitionDetail.supervisorComments
															}
														</p>
													)}
												</Col>
											</Row>
											{itemStatus === "Pending" ? (
												<div className="btns">
													<Button
														className="submit-btn"
														onClick={handleSubmit}
													>
														Submit
													</Button>
												</div>
											) : null}
										</Form>
									)}
								</Formik>
							</div>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ReviewItemRequisitionDetail;
